import { gql } from '@apollo/client';

import { FragmentFacetsAll } from '../../fragments/facets';
import { FragmentVehiclesPCP } from '../../fragments/vehicles/pcp';

export const QueryFacets = gql`
  query Facets($origin: String) {
    ...FragmentFacetsAll
  }
  ${FragmentFacetsAll}
`;

export const QueryVehicles = gql`
  query QueryVehicles(
    $filter: VehicleFilterOptions
    $sorting: VehicleSortingOptions
    $pager: SearchResultPager
  ) {
    ...FragmentVehiclesPCP
  }
  ${FragmentVehiclesPCP}
`;
